export default {
  state: {
    userAgent: navigator.userAgent,
  },

  getters: {
    browserName: (state) => {
      const userAgent = state.userAgent.toLowerCase();
      if (/msie|trident/.test(userAgent)) return "Internet Explorer";
      if (/edge/.test(userAgent)) return "Edge";
      if (/chrome/.test(userAgent)) return "Chrome";
      if (/firefox/.test(userAgent)) return "Firefox";
      if (/safari/.test(userAgent)) return "Safari";
      if (/opera/.test(userAgent)) return "Opera";
      return "Unknown";
    },

    isOnDesktop: (state) => {
      return !/Mobile|Tablet/.test(state.userAgent);
    },

    isOnTablet: (state) => {
      return (
        /iPad|Android/.test(state.userAgent) && !/Mobile/.test(state.userAgent)
      );
    },

    isOnMobile: (state) => {
      return /IEMobile|Windows Phone|Lumia|iP(hone|od)|Android|BlackBerry|PlayBook|BB10|Mobile Safari|webOS|Mobile|Tablet|Opera Mini|\bCrMo\/|Opera Mobi/i.test(
        state.userAgent,
      );
    },

    osName: (state) => {
      const userAgent = state.userAgent.toLowerCase();
      if (/windows/.test(userAgent)) return "Windows";
      if (/android/.test(userAgent)) return "Android";
      if (/macintosh|mac os x/.test(userAgent)) return "Mac";
      if (/ios/.test(userAgent)) return "iOS";
      if (/linux/.test(userAgent)) return "Linux";
      return "Unknown";
    },
  },

  mutations: {
    UPDATE_USER_AGENT(state) {
      state.userAgent = navigator.userAgent;
    },
  },
};
